import type { CardKind, Role } from './types';

const ART_BASE = '/art/generated';

const CARD_FILE: Record<CardKind, string> = {
  hack: 'card-hack.webp',
  firewall: 'card-firewall.webp',
  cipherShield: 'card-cipher-shield.webp',
  rig: 'card-rig.webp',
  overclock: 'card-overclock.webp',
  longwave: 'card-longwave.webp',
  raid: 'card-raid.webp',
  downtime: 'card-downtime.webp',
  medPatch: 'card-med-patch.webp',
  payday: 'card-payday.webp',
  duel: 'card-duel.webp',
  emp: 'card-emp.webp',
  virus: 'card-virus.webp',
  siphon: 'card-siphon.webp',
  stim: 'card-stim.webp',
  trace: 'card-trace.webp',
  airGap: 'card-air-gap.webp',
  killSwitch: 'card-kill-switch.webp',
  backchannel: 'card-backchannel.webp',
  fieldPatch: 'card-field-patch.webp',
  coldReboot: 'card-cold-reboot.webp',
  packetStorm: 'card-packet-storm.webp',
};

export const tableArenaDesktop = `${ART_BASE}/table-arena-desktop-v3.webp`;
export const tableArenaMobile = `${ART_BASE}/table-arena-mobile.webp`;
export const homeHeroDesktop = `${ART_BASE}/home-hero-desktop.webp`;
export const homeHeroMobile = `${ART_BASE}/home-hero-mobile.webp`;
export const lobbyBgDesktop = `${ART_BASE}/lobby-bg-desktop.webp`;
export const lobbyBgMobile = `${ART_BASE}/lobby-bg-mobile.webp`;
export const duelBgDesktop = `${ART_BASE}/duel-bg-desktop.webp`;
export const duelBgMobile = `${ART_BASE}/duel-bg-mobile.webp`;
export const playerPanelBg = `${ART_BASE}/player-panel-bg.webp`;
export const codexBg = `${ART_BASE}/codex-bg.webp`;
export const cardBackArt = `${ART_BASE}/card-back.webp`;
/** Shop card-back skins (generated art), e.g. cardBackVariant('cyan'). */
export const cardBackVariant = (key: string) => `${ART_BASE}/card-back-${key}.webp`;
export const panelTexture = `${ART_BASE}/panel-texture.webp`;
export const damageOverlay = `${ART_BASE}/fx-damage-overlay.webp`;

export function cardArt(kind: CardKind): string {
  return `${ART_BASE}/${CARD_FILE[kind]}`;
}

export function characterArt(characterId?: string | null): string | null {
  return characterId ? `${ART_BASE}/character-${characterId}.webp` : null;
}

export function roleArt(role: Role): string {
  return `${ART_BASE}/role-${role}.webp`;
}

export function endingArt(winner: 'directorSide' | 'rebels' | 'fixer' | null): string | null {
  if (winner === 'directorSide') return `${ART_BASE}/ending-corp.webp`;
  if (winner === 'rebels') return `${ART_BASE}/ending-rebel.webp`;
  if (winner === 'fixer') return `${ART_BASE}/ending-fixer.webp`;
  return null;
}
